import {Box, BoxProps} from '@mui/material'
import React from 'react'
import {useLocation, useNavigate, useSearchParams} from 'react-router'

import {getPersistedSearchParams} from '../../utils'

interface TableCellNavigateProps extends Omit<BoxProps, 'onClick'> {
  children: React.ReactNode
  to: string
}

export const TableCellNavigate: React.FC<TableCellNavigateProps> = ({children, to, ...rest}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()

  return (
    <Box
      onClick={() =>
        navigate(
          {pathname: to, search: getPersistedSearchParams(searchParams).toString()},
          {state: location}
        )
      }
      sx={{
        height: '100%',
        width: '100%'
      }}
      {...rest}
    >
      {children}
    </Box>
  )
}
